// extracted by mini-css-extract-plugin
export default {"div":"Pay_div__Jxf9T","paymentdiv":"Pay_paymentdiv__cO3ad","button":"Pay_button__VUzTD","add":"Pay_add__ii-Ie"};